import React from "react";
import { Navigate } from "react-router-dom";
import { useActivitiesAccess } from "../hooks/useActivitiesAccess";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import NotFoundPage from "../pages/NotFound";

interface ActivitiesProtectedRouteProps {
    children: JSX.Element;
    isLoggedIn: boolean;
}

/**
 * Protected route for Activities that checks:
 * - User is logged in
 * - Company has activities addon
 */
const ActivitiesProtectedRoute: React.FC<ActivitiesProtectedRouteProps> = ({ children, isLoggedIn }) => {
    const { hasAccess, loading } = useActivitiesAccess();

    // Show loading state while checking access
    if (loading) {
        return <LoadingSpinner size={50} />;
    }

    // Redirect to login if not logged in
    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    // Show 404 if no access (addon not enabled)
    if (!hasAccess) {
        return <NotFoundPage />;
    }

    return children;
};

export default ActivitiesProtectedRoute;
